import { useSelector } from "react-redux";
import { getActivePageName } from "./selectors";

export const useActivePageName = () => useSelector(getActivePageName);
